module.exports = __webpack_public_path__ + "img/my_award.72de4ba4.png";